import React from 'react';
import {ReviewSearchStatisticsResource} from "../../../services/api/ReviewService";

interface Props {
    stats: ReviewSearchStatisticsResource

}

const ReviewCharacteristicsSummary = ({stats}: Props) => {
    return (
        <div className="reviewCharSummary-container">
            {stats.attributes.map(attr => (
                <div className="reviewCharSummary-char-container">
                    <div className="reviewCharSummary-stat-bar">
                        <div style={{height: attr.value + '%'}}/>
                    </div>
                    <span>{attr.label}</span>
                </div>
            ))}
        </div>
    )
}

export default ReviewCharacteristicsSummary;